import React from 'react';
import { Trans } from '@lingui/macro';

function Festival() {
  return (
    <section className="section bg-light" id="festival">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12 mb-2 pb-2">
            <div className="section-title text-center">
              <h2 className="mb-4">
                <Trans>Welcome to Amaré Music Festival</Trans>
              </h2>
              <p className="lead mb-4">
                <Trans>
                  Get ready to experience the magic of electronic music like never before. With a breathtaking stage, world-class DJs, and an unforgettable atmosphere, step into this enchanted realm where your dreams become reality.
                </Trans>
              </p>
              <p className="lead mb-1">
                {/* <Trans>Join us for the second edition of Amaré Music Festival!</Trans> */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Festival;